import script from "./PlanChooser.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanChooser.vue?vue&type=script&setup=true&lang=js"

import "./PlanChooser.vue?vue&type=style&index=0&id=0fd03e58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fd03e58"]])

export default __exports__